<script setup lang="ts">
  import { onBeforeMount, ref } from 'vue';
  import { useRoute } from 'vue-router';

  import { ComboSelect } from '@ui/components/combo-select';

  interface Props {
    queryName?: string;
  }

  interface ActionOption {
    label: string;
    value: string[];
  }

  withDefaults(defineProps<Props>(), {
    queryName: 'expected_action',
  });

  const emit = defineEmits<{
    (e: 'update', value: string[]): void;
  }>();

  const route = useRoute();
  const selectedAction = ref<ActionOption | null>(null);

  const actionOptions: ActionOption[] = [
    {
      label: 'Acknowledge',
      value: ['acknowledge'],
    },
    {
      label: 'Completion',
      value: ['complete', 'complete_with_action'],
    },
  ];

  onBeforeMount(() => {
    if (route.query?.expected_action) {
      const actionQuery = route.query.expected_action;
      const actionArray = Array.isArray(actionQuery) ? actionQuery : [actionQuery];

      const matchingOption = actionOptions.find((option) =>
        option.value.every((v) => actionArray.includes(v)),
      );

      if (matchingOption) {
        selectedAction.value = matchingOption;
      }
    }
  });

  defineExpose({
    selectedAction,
  });
</script>

<template>
  <ComboSelect
    v-model="selectedAction"
    :options="actionOptions"
    variant="filter"
    placeholder="Required Action"
    :multiple="false"
    option-identifier="label"
    @update:model-value="(action) => emit('update', (action as ActionOption | null)?.value ?? [])"
  >
    <template #filter-label>
      <i class="fa-regular fa-hand-pointer" />
      <span> Required Action </span>
    </template>
  </ComboSelect>
</template>
